
import { ReactNode, Suspense } from "react";
import Sidebar from "../sidebar/Sidebar";
import TopHeader from "../sidebar/TopHeader";
import Footer from "../sidebar/Footer";

export default function InnerLayout({ children }: { children: ReactNode}) {

    return (
        <>
            <Sidebar />
            <div className="wrapper flex grow flex-col">
                <TopHeader />
                <div className="grow content pt-5">
                    <Suspense fallback={<div>Loading...</div>}>
                        {children}
                    </Suspense>
                </div>
                <Footer />
            </div>
        </>
    );
}
